/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/* import { LogLevel } from '@azure/msal-browser'; */

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {

        /* org */        
        /* clientId: 'Enter_the_Application_Id_Here', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://Enter_the_Tenant_Subdomain_Here.ciamlogin.com/', // Replace the placeholder with your tenant subdomain 
        redirectUri: 'http://localhost:3000/redirect', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response. */

        /* linde-dev */
        /* clientId: '013978c2-ae1c-4816-b7c8-5bfb7cf7c4ec', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://login.microsoftonline.com/fd206715-7509-4ae5-9b96-76bb97886a84', // Replace the placeholder with your tenant subdomain 
        redirectUri: 'https://linde-dev.onetenplus.com/authentication/login-callback', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        // redirectUri: 'http://localhost:8000', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration. */
       
        /* linde-tst */
        /* clientId: '160ffcf0-ab87-4478-8856-e92013883e1b', // '160ffcf0-ab87-4478-8856-e92013883e1b', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://login.microsoftonline.com/1562f007-09a4-4fcb-936b-e79246571fc7', // Replace the placeholder with your tenant subdomain 
        redirectUri: 'https://tst.tanktelemetryth.linde.com/authentication/login-callback', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        clientSecret: '7-U8Q~efF6HJofRTPv-rpJjHSHG43tLXqfMA0bma' // 'eZd8Q~AuZ7p9NyeeA0uKwgct-Ok62cLlwMevncwq', */

        /* linde-prd */
        clientId: '304859eb-2cf7-4f31-84d2-a4b407f91b6e', // '160ffcf0-ab87-4478-8856-e92013883e1b', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://login.microsoftonline.com/1562f007-09a4-4fcb-936b-e79246571fc7', // Replace the placeholder with your tenant subdomain 
        redirectUri: 'https://tanktelemetryth.linde.com/authentication/login-callback/', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        clientSecret: 'Buj8Q~NWi6Zq9RfqpR4fahbTjmr8cR1yCWoXXc.0' // 'eZd8Q~AuZ7p9NyeeA0uKwgct-Ok62cLlwMevncwq',

        /* 
            App Name: LG_APAC-TH_EA972_Tank-Telemetry_TST [ Client ID: 160ffcf0-ab87-4478-8856-e92013883e1b] .

            Client Secret:  7-U8Q~efF6HJofRTPv-rpJjHSHG43tLXqfMA0bma

            Expiry: 8/12/2025 [ MM/DD/YYYY]
        */

        // /* linde-test */
        // /* clientId: '160ffcf0-ab87-4478-8856-e92013883e1b', // '160ffcf0-ab87-4478-8856-e92013883e1b', // This is the ONLY mandatory field that you need to supply.
        // authority: 'https://login.microsoftonline.com/1562f007-09a4-4fcb-936b-e79246571fc7', // Replace the placeholder with your tenant subdomain 
        // redirectUri: 'https://tst.tanktelemetryth.linde.com/authentication/login-callback', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        // clientSecret: 'Y3z8Q~e34sJ.MRS4lrxdD4xj._c1NHjI7~HS0aTS' // 'eZd8Q~AuZ7p9NyeeA0uKwgct-Ok62cLlwMevncwq', */

    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    /* system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    }, */
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: [],
    scopes: [ 'user.read' ]
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };